import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './i18n'
import './styles/global.css'
import './styles/app.css'
import './styles/studio.css'
import './styles/scene-preview.css'
import './styles/editor.css'
import './styles/export.css'
import { initAnalytics } from './utils/analytics'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* SPA 在生产由 Go embed.FS 挂在 /studio/，故 basename=/studio；开发期 Vite base 同。 */}
    <BrowserRouter basename="/studio">
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)

// 启动后异步加载 GA（从 /exports/config 获取 GA ID，空=不加载）
void initAnalytics()
